<div *ngIf="(listing.thumbnail?.assetPath || parentListing?.thumbnail?.assetPath) as assetPath" class="preview">
	<img [src]="assetPath" />
</div>

<div class="card-body" *localVar="settings$ | async as settings">
	<div *ngIf="listing.name" class="name" [innerHTML]="(listing.name | getLocale:listing.locale?.name) | highlightMatch:highlightQuery"></div>
	<div *ngIf="listing.summary" class="summary" [innerHTML]="(listing.summary | getLocale:listing.locale?.summary) | highlightMatch:highlightQuery"></div>

	<div *ngIf="!listing.isLegacyVideoTemplate" class="meta flex">
		<div class="meta-row" [tp]="tpl" tpPlacement="right" [tpData]="{ units: visibleCreativeUnitsNames }">
			<mat-icon inline>aspect_ratio</mat-icon>
			<span class="ml-1">{{ visibleCreativeUnitsNames?.length }}</span>
		</div>
		<div class="meta-row ml-2">
			<span *ngFor="let exportType of exportTypes; let i = index" class="strong tag">
				<ng-container *ngIf="exportType === ExportType.STATIC" i18n="Export Type@@creativeUnitPackageListingCardStaticExportTypeLabel">Static</ng-container>
				<ng-container *ngIf="exportType === ExportType.VIDEO" i18n="Export Type@@creativeUnitPackageListingCardVideoExportTypeLabel">Video</ng-container>
				<ng-container *ngIf="exportType === ExportType.HTML5" i18n="Export Type@@creativeUnitPackageListingCardHtml5ExportTypeLabel">HTML5</ng-container>
				<ng-container *ngIf="exportType === ExportType.AUDIO" i18n="Export Type@@creativeUnitPackageListingCardAudioExportTypeLabel">Audio</ng-container>
				<ng-container *ngIf="exportType === 'print'" i18n="Export Type@@creativeUnitPackageListingCardPrintExportTypeLabel">Print</ng-container>
				<ng-container *ngIf="exportType === ExportType.EMAIL" i18n="Export Type@@creativeUnitPackageListingCardEmailExportTypeLabel">Email</ng-container>
			</span>
		</div>

		<div *ngIf="listing.children?.length" class="right">
			<mat-icon inline>account_tree</mat-icon>
			<span class="ml-1">{{ listing.children?.length }}</span>
		</div>
	</div>
</div>


<ng-template #tpl let-hide let-data="data">
	<ng-container *ngFor="let unit of data.units; let i = index;">
		<span>{{ unit.name | getLocale:unit.locale?.name }}</span><span *ngIf="i < data.units.length"><br></span>
	</ng-container>
</ng-template>
